<div class="row" *ngIf="user">
  <div class="col-md-8">
    <safetydirector-news></safetydirector-news>
    <safetydirector-promotedlinks></safetydirector-promotedlinks>
  </div>
  <div class="col-md-4">
    <safetydirector-events></safetydirector-events>
    <safetydirector-top-resources [size]="5" [industry]="industry"></safetydirector-top-resources>
  </div>
</div>
